import Vuex from 'vuex';
import Vue from 'vue';
import { createProxy, extractVuexModule } from 'vuex-class-component';
import ContractStore from './contract.store';
import StepperStore from './stepper.store';
import HeaderStore from './header.store';
import BreadCrumbStore from './breadcrumb.store';
import { MainAlertStore } from './main-alert.store';
Vue.use(Vuex);
export const store = new Vuex.Store({
  modules: {
    ...extractVuexModule(ContractStore),
    ...extractVuexModule(StepperStore),
    ...extractVuexModule(HeaderStore),
    ...extractVuexModule(BreadCrumbStore),
    ...extractVuexModule(MainAlertStore),
  },
});

export const moduleProxy = {
  Contract: createProxy(store, ContractStore),
  Stepper: createProxy(store, StepperStore),
  Header: createProxy(store, HeaderStore),
  BreadCrumb: createProxy(store, BreadCrumbStore),
  mainAlert: createProxy(store, MainAlertStore),
};
